import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import 'core-js/fn/array/map';
import 'core-js/fn/array/find';
import 'core-js/fn/string/includes';
import 'core-js/fn/array/from';
import 'classlist-polyfill';

import { Router, Route } from 'react-router'

import createBrowserHistory from 'history/createBrowserHistory'
const history = createBrowserHistory()

ReactDOM.render(
    <Router history={history}>
        <Route path="/:lang?" component={App}/>
    </Router>
    , document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js